import React from 'react';
import { isProductionApp } from '../../Services/environment';

const TagManager = () => {
    if (!isProductionApp()) {
        return null;
    }

    return <>
        <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MBJMB2HT"
            title="Google Tag Manager"
            className="hidden invisible"
            height="0"
            width="0"
        />
    </>
}

export default TagManager;